<template>
    <div>
        <ob-modal2 :show.sync="showsharePopup" width="600px" :backdrop="false">
            <template slot="modal-title">
                <div class="modal-head">
                    <h4 class="modal-title">
                        {{modalTitle}}
                    </h4>
                </div>
            </template>

            <template slot="modal-body">
                <transition name="slide-fade">
                    <div v-if="showsharePopup">
                        <div class="row">
                            <div class="col-md-12">
                                <div style="padding-left:17px;">
                                    <label>Select the recipient</label>
                                </div>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom:10px;">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="col-md-6">
                                        <div style="padding-left: 0;" class="radio-inline">
                                            <ob-radio name="options" v-model="selectrecipientType" val="DSO">Designated school officials (DSO)</ob-radio>
                                        </div>
                                    </div>
                                    <div class="col-md-3" v-if="isHRManager">
                                        <div class="radio-inline">
                                            <ob-radio name="options1" v-model="selectrecipientType" val="Student">Student</ob-radio>
                                        </div>
                                    </div>
                                    <div v-else class="col-md-3">
                                        <div class="radio-inline">
                                            <ob-radio name="options1" v-model="selectrecipientType" val="Employer">Employer</ob-radio>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="radio-inline">
                                            <ob-radio name="options2" v-model="selectrecipientType" val="Other">Other</ob-radio>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="selectrecipientType == 'DSO'">
                            <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>DSO Name</label><span class="validation-star">*</span>
                                            <ob-input v-model="DSODetails.Name" v-formi9-name placeholder="Name" :class="{ 'ob-vuelidate_input-error': $v.DSODetails.Name.$error }" @input="updateValue('dsoName', DSODetails.Name)"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.DSODetails.Name.$dirty && !$v.DSODetails.Name.required"> Enter DSO name</span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.DSODetails.Name.$dirty && !$v.DSODetails.Name.maxLength && !$v.DSODetails.Name.alpha"> Enter 35 characters only</span>
                                        </div>

                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>DSO Email Address</label><span class="validation-star">*</span>
                                            <ob-input v-model="DSODetails.EmailAddress" placeholder="Email Address" :class="{ 'ob-vuelidate_input-error': $v.DSODetails.EmailAddress.$error }"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.DSODetails.EmailAddress.$dirty && !$v.DSODetails.EmailAddress.required"> Enter  Email Id</span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.DSODetails.EmailAddress.$dirty && !$v.DSODetails.EmailAddress.email"> Enter valid email</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        <div class="row" v-if="selectrecipientType == 'Student'">
                            <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Student Name</label><span class="validation-star">*</span>
                                                <ob-input v-formi9-name v-model="StudentDetails.Name" placeholder="Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.Name.$error }" @input="updateValue('studentName', StudentDetails.Name)"></ob-input>
                                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.required"> Enter Student name</span>
                                        <!-- <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.alphawithspace"> Enter alphabets only</span> -->
                                        <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.maxLength && !$v.StudentDetails.Name.alpha"> Enter 35 characters only</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Student Email Address</label><span class="validation-star">*</span>
                                            <ob-input v-model="StudentDetails.EmailAddress" placeholder="Email Address" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.EmailAddress.$error }"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmailAddress.$dirty && !$v.StudentDetails.EmailAddress.required"> Enter  Email Id</span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmailAddress.$dirty && !$v.StudentDetails.EmailAddress.email"> Enter valid email</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="selectrecipientType == 'Employer'">
                            <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Employer Name</label><span class="validation-star">*</span>
                                            <ob-input v-formi9-name v-model="EmployerDetails.Name" placeholder="Name" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.Name.$error }" @input="updateValue('empName', EmployerDetails.Name)"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Name.$dirty && !$v.EmployerDetails.Name.required"> Enter Student name</span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.Name.$dirty && !$v.EmployerDetails.Name.maxLength && !$v.EmployerDetails.Name.alpha"> Enter 35 characters only</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Employer Email Address</label><span class="validation-star">*</span>
                                            <ob-input v-model="EmployerDetails.EmailAddress" placeholder="Email Address" :class="{ 'ob-vuelidate_input-error': $v.EmployerDetails.EmailAddress.$error }"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmailAddress.$dirty && !$v.EmployerDetails.EmailAddress.required"> Enter  Email Id</span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.EmployerDetails.EmailAddress.$dirty && !$v.EmployerDetails.EmailAddress.email"> Enter valid email</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        <div class="row" v-if="selectrecipientType == 'Other'">
                            <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Name</label><span class="validation-star">*</span>
                                            <ob-input v-model="OtherDetails.Name" v-formi9-name placeholder="Name" :class="{ 'ob-vuelidate_input-error': $v.OtherDetails.Name.$error }" @input="updateValue('otherName', OtherDetails.Name)"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.OtherDetails.Name.$dirty && !$v.OtherDetails.Name.required"> Enter name</span>
                                            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.OtherDetails.Name.$dirty && !$v.OtherDetails.Name.alphawithspace"> Enter alphabets only</span> -->
                                            <span class="ob-vuelidate_error-msg" v-if="$v.OtherDetails.Name.$dirty && !$v.OtherDetails.Name.maxLength && !$v.OtherDetails.Name.alpha"> Enter 35 characters only</span>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Email Address</label><span class="validation-star">*</span>
                                            <ob-input v-model="OtherDetails.EmailAddress" placeholder="Email Address" :class="{ 'ob-vuelidate_input-error': $v.OtherDetails.EmailAddress.$error }"></ob-input>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.OtherDetails.EmailAddress.$dirty && !$v.OtherDetails.EmailAddress.required"> Enter  Email Id</span>
                                            <span class="ob-vuelidate_error-msg" v-if="$v.OtherDetails.EmailAddress.$dirty && !$v.OtherDetails.EmailAddress.email"> Enter valid email</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </transition>
            </template>

            <template slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="onCancel">Cancel</button>
                <button type="button" class="btn btn-primary" @click="onNext">Next</button>
            </template>
        </ob-modal2>
        <compose-mail-popup  :show.sync="showComposeMailpopup" :mailDetails.sync="mailDetails"></compose-mail-popup>
    </div>
</template>
<script>
    import namevalidation from "Vue/Core/namevalidation.js"
    import ComposeI983MailPop from './ComposeI983MailPop.vue'
    import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators';
    const alphawithspace = (value) => {
    var alsp = /^[a-zA-Z\s]*$/i
    return alsp.test(value)
  }
    export default {
        props: ["sharePopup","shareDetails"],
        data()
         {
            return {

                 DSODetails :
                 {
                     Name :'',
                     EmailAddress :'',
                 },
                  StudentDetails :
                 {
                     Name :'',
                     EmailAddress :'',
                 },
                 EmployerDetails :
                 {
                     Name :'',
                     EmailAddress :'',
                 },

                 OtherDetails :
                 {
                     Name: '',
                     EmailAddress :'',
                 },

                showsharePopup: '',
                selectrecipientType: "DSO",
                showComposeMailpopup: false,
                mailDetails:'',
            }
        },
        watch: {
                sharePopup(val) {
                    this.showsharePopup = val;
                    if(val === true) { //  on modal open
                        this.resetData(); // Empty any previous values
                        this.copyFromStore(); // Copy values from store
                    }
                },
                // shareDetails(val)
                // {
                //   this.copyFromStore();
                // },
                showsharePopup(val) {
                    this.$emit('update:sharePopup', val)
                },
        },

        computed: {
            modalTitle() {
                let sectionType = this.shareDetails ? this.shareDetails.Sectiontype : '';
                if(sectionType == "SignedForm") {
                    return 'Share Signed Form I-983';
                } else if(sectionType == "CompleteForm") {
                    return 'Share Complete Form I-983';
                } else if(sectionType == "Student") {
                    return 'Share Student Information';
                } else if(sectionType == "Employer") {
                    return 'Share Employer Information';
                } else if(sectionType == "AssignedTraining") {
                    return 'Share Training Plan for Stem OPT Students';
                }

                return 'Share for Stem OPT Students';
            }
        },
        created() {
            this.showsharePopup = this.sharePopup
        },

        methods: {
            updateValue(modelName, value){
              let val = namevalidation.getValidName(value);
              if(modelName == "studentName")
                this.StudentDetails.Name = val
              else if(modelName == "dsoName")
                this.DSODetails.Name = val
              else if(modelName == "empName")
                this.EmployerDetails.Name = val
              else
                this.OtherDetails.Name = val
            },
            copyFromStore() {
                this.StudentDetails.Name = this.shareDetails.StudentName;
                this.StudentDetails.EmailAddress = this.shareDetails.StudentEmail;
                this.EmployerDetails.Name = this.shareDetails.EmployerName;
                this.EmployerDetails.EmailAddress = this.shareDetails.EmployerEmail;
                this.DSODetails.Name = this.shareDetails.DSOName;
                this.DSODetails.EmailAddress = this.shareDetails.DSOMail;
            },
            resetData()
            {
                this.DSODetails.Name ='',
                this.DSODetails.EmailAddress ='',
                this.EmployerDetails.Name  ='',
                this.EmployerDetails.EmailAddress  ='',
                this.OtherDetails.Name ='',
                this.OtherDetails.EmailAddress  ='',
                this.selectrecipientType = "DSO";

                // Reset Validations
                this.$v.DSODetails.$reset();
                this.$v.StudentDetails.$reset();
                this.$v.EmployerDetails.$reset();
                this.$v.OtherDetails.$reset();

            },
            onNext() {
                var isValid = false
                var mailDetails = ''
                if(this.selectrecipientType == 'DSO')
                {
                  this.$v.DSODetails.$touch()
                  if(this.$v.DSODetails.$invalid == false )
                  {
                      mailDetails = {
                          Id:this.shareDetails.Id,
                          RecipientName : this.DSODetails.Name,
                          EmailId:this.DSODetails.EmailAddress,
                          SectionType:this.shareDetails.Sectiontype,
                          RecipientType:'DSO',
                          Attachments:this.shareDetails.DocUrl,
                          Type: this.shareDetails.Type,
                          DocumentUrl : this.shareDetails.DocUrl,
                          IsDocument : this.shareDetails.IsDocument,
                      }
                      isValid = true
                  }
                }
                else if(this.selectrecipientType == 'Student')
                {
                        this.$v.StudentDetails.$touch();
                        if(this.$v.StudentDetails.$invalid == false )
                        {
                             mailDetails = {
                                Id:this.shareDetails.Id,
                                RecipientName : this.StudentDetails.Name,
                                EmailId:this.StudentDetails.EmailAddress,
                                SectionType:this.shareDetails.Sectiontype,
                                RecipientType:'Student',
                                Attachments:this.shareDetails.DocUrl,
                                Type: this.shareDetails.Type,
                                IsDocument : this.shareDetails.IsDocument,
                            }
                            isValid = true
                        }
                }
                else if(this.selectrecipientType == 'Employer')
                {
                        this.$v.EmployerDetails.$touch();
                        if(this.$v.EmployerDetails.$invalid == false )
                        {
                             mailDetails = {
                                Id:this.shareDetails.Id,
                                RecipientName : this.EmployerDetails.Name,
                                EmailId:this.EmployerDetails.EmailAddress,
                                SectionType:this.shareDetails.Sectiontype,
                                RecipientType:'Employer',
                                Attachments:this.shareDetails.DocUrl,
                                Type: this.shareDetails.Type,
                                IsDocument : this.shareDetails.IsDocument,
                            }
                            isValid = true
                        }
                }
                else
                {
                       this.$v.OtherDetails.$touch();
                       if(this.$v.OtherDetails.$invalid == false )
                        {
                            mailDetails = {
                                Id:this.shareDetails.Id,
                                RecipientName : this.OtherDetails.Name,
                                EmailId:this.OtherDetails.EmailAddress,
                                SectionType:this.shareDetails.Sectiontype,
                                RecipientType:'Other',
                                Attachments:this.shareDetails.DocUrl,
                                Type: this.shareDetails.Type,
                                IsDocument : this.shareDetails.IsDocument,
                            }
                            isValid = true
                        }
                }
               if(isValid)
               {
                    this.mailDetails = mailDetails
                    this.resetData()
                    this.showsharePopup = false
                    this.showComposeMailpopup = true
               }
        },
        onCancel()
        {
           this.resetData()
           this.showsharePopup = false
        }

    },

          validations()
          {
               return{

                  DSODetails:
                                {
                                     "Name":{
                                            required,
                                             maxLength: maxLength(35)
                                        },
                                        "EmailAddress":{
                                             required,
                                             email
                                        },

               },
                StudentDetails:
                                {
                                       "Name":{
                                            required,
                                            // alphawithspace,
                                             maxLength: maxLength(35)

                                        },
                                        "EmailAddress":{
                                            required,
                                            email
                                        },

               },
               EmployerDetails:
               {
                   "Name":{
                                            required,
                                             maxLength: maxLength(35)

                                        },
                                        "EmailAddress":{
                                            required,
                                            email
                                        },
               },
                OtherDetails:
                                {
                                       "Name":{
                                            required,
                                            // alphawithspace,
                                             maxLength: maxLength(35)

                                        },
                                        "EmailAddress":{
                                             required,
                                             email
                                        },

               }

          }
      },

        components: {
            "compose-mail-popup" : ComposeI983MailPop
        }

    }
</script>
<style lang="scss" scoped>
    .content {
        color: #4a90e2;
        font-size: 14px;
    }

    .validation-star {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/ShareI983Popup.vue